import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ResponseTranslation } from '@app/models/translations';

// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
interface LocalizedField {
  [langCode: string]: string;
}

type LocalizedValue = LocalizedField | ResponseTranslation;

@Pipe({
  name: 'localized',
  standalone: true,
  pure: false,
})
export class TranslateLocalizedPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: LocalizedValue | null | undefined): string {
    if (!value) return '';
    const lang = this.translateService.currentLang || this.translateService.getDefaultLang();

    const localizedObj = value as Record<string, string>;
    return localizedObj[lang] || localizedObj['en'] || '';
  }
}
